<template>
    <Head :title="t('home.teaser:headlines').join(' ')" />

    <div class="mx-auto max-w-3xl pb-8" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser :headlines="t('home.teaser:headlines')" :subline="t('home.teaser:subline')"></Teaser>
            </div>
        </div>
        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <UploadBox :metaDataType="metaDataType" v-if="metaDataType.type !== 'poem'"></UploadBox>
                <UploadNextBox :metaDataType="metaDataType" v-if="metaDataType.type === 'poem'"></UploadNextBox>
            </div>
        </div>
        <Steps :step="1"></Steps>

    </div>

    <!--InfoPanel></InfoPanel-->
    <!--StatsPanel></StatsPanel-->
    <LatestNfts></LatestNfts>
    <FAQ></FAQ>
</template>


<script setup>
import FAQ from './../../Components/FAQ';
import UploadBox from './../../Components/UploadBox';
import UploadNextBox from './../../Components/UploadNextBox';
import Steps from "../../Components/Steps";
import LatestNfts from "../../Components/LatestNfts";
import InfoPanel from "../../Components/InfoPanel";
import StatsPanel from "../../Components/StatsPanel";
import {Head, usePage} from '@inertiajs/inertia-vue3'
import translate from '../../../lang';
import Teaser from "../../Components/Common/Teaser";

defineProps({
        metaDataType: Object
});
const t = translate('upload-' + usePage().props.value.metaDataType.type);

</script>
